// removed by extract-text-webpack-plugin
module.exports = {"loading":"root-module__loading___KZAq1","spinner":"root-module__spinner___TqnLl","root":"root-module__root___mK1MC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.module.scss
// module id = 879
// module chunks = 0 1